module.exports = __webpack_public_path__ + "img/exam-manager-6.a20d5264.svg";